// Copyright (c) Hamilton Manufacturing Corp.
import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { lastKeyPress, mobileView } from './api/utility';
import Button from './form/Button';
import { useGlobalState } from './globalState/GlobalStateProvider';

const fallDown = keyframes`
    0% { transform: translateY(-50svh); }
    70% { transform: translateY(-25svh); }
    100% { transform: translateY(-30svh); }
`;

const riseUp = keyframes`
    0% { transform: translateY(-30svh); }
    30% { transform: translateY(-25svh); }
    100% { transform: translateY(-50svh); }
`;

const Frame = styled.div`
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    justify-content: center;
    align-items: center;
    background: #6c6c6c87;
    transition: opacity 0.15s linear;
    position: fixed;
    display: flex;

    animation: ${({ showing }) => showing ? 'fadeIn' : 'fadeOut'};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
`
const Body = styled.div`
    background: ${({ theme }) => theme.modal.body};
    border-radius: 0.5rem;
    position: relative;
    animation: growin 0.5s;
    overflow: hidden;
    transition: all 0.15s ease-in-out;
    max-width: ${({ mobile }) => mobile ? '97%' : '50%'};
    min-width: ${({ mobile }) => mobile ? '85vw' : '25%'};
    box-shadow: 5px 5px 20px 0 #00000082;

    animation: ${({ showing }) => showing ? fallDown : riseUp};
    animation-duration: 0.3s;
    animation-fill-mode: forwards;
`
const Margin = styled.div`
    height: 100%;
    width: 10px;
    position: absolute;
    background: ${({ theme, type }) => theme.modal[type] || theme.modal.alert};
`
const Wrapper = styled.div`
    padding: ${({ mobile }) => mobile ? '0.5em 1em' : '0.5em 2.5rem'};
`
const Footer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0;
`

const QRModal = ({ ...props }) => {
    const { state: { }, } = useGlobalState();

    const defaultModal = {
        show: false,
        title: 'Test',
        type: 'alert',
        body: 'Why can you see this?',
        buttons: [],
        icon: '',
        hideClose: false
    }

    const [showing, setShowing] = useState(false);
    const [followUp, setFollowUp] = useState(false);
    const [modal, setModal] = useState(defaultModal)

    const handleClose = (follow) => {
        return new Promise((resolve) => {
            setShowing(false);
            if (!follow) setFollowUp(false)
            setTimeout(() => {
                if (modal.promise) {
                    modal.promise(true)
                }
                setModal(defaultModal)
                setTimeout(() => {
                    resolve(true)
                }, 50);
            }, 300);
        });
    }

    const showModal = async config => {
        if (modal.show) {
            setFollowUp(true)
            await handleClose(true);
        }
        setShowing(true)
        lastKeyPress.registerListener(key => {
            if (key === 'Escape') handleClose();
        });

        return new Promise((resolve) => {
            setModal({
                ...config,
                show: true,
                promise: resolve
            })
        })
    }

    QRModal.Show = showModal;
    QRModal.Close = handleClose;

    return modal.show && (
        <Frame showing={showing}>
            <Body mobile={mobileView} showing={showing} followUp={followUp}>
                <Margin type={modal.type} />
                <Wrapper mobile={mobileView}>
                    {modal.body}
                    <Footer>
                        {modal.buttons}
                        <Button autoFocus onClick={() => handleClose()}>Close</Button>
                    </Footer>
                </Wrapper>
            </Body>
        </Frame>
    );
}

export default QRModal;